(ns hai.ui.components
  "Wrapper for radix-ui/themes components, and potential extension point for us to
  modify/replace/augment these components, or use our own that use the same
  design tokens (CSS variables.)"
  {:ornament/prefix ""}
  #?(:cljs (:require-macros hai.ui.components))
  (:refer-clojure :exclude [Box])
  (:require
   #?@(:cljs [["react" :as react]
              ["@radix-ui/themes" :as radix-ui-themes]
              [reagent.core :as reagent]
              [reagent.dom :as reagent.dom]])
   [lambdaisland.ornament :as o]))

;; Some tokens defined by radix-themes, use these to get light/dark mode support
(o/defprop --color-background)
(o/defprop --color-overlay)
(o/defprop --color-panel-solid)
(o/defprop --color-panel-translucent)
(o/defprop --color-surface)
(o/defprop --shadow-1)
(o/defprop --shadow-2)
(o/defprop --shadow-3)
(o/defprop --shadow-4)
(o/defprop --shadow-5)
(o/defprop --shadow-6)

(o/defprop --gray-1)
(o/defprop --gray-2)
(o/defprop --gray-3)
(o/defprop --gray-4)
(o/defprop --gray-5)
(o/defprop --gray-6)
(o/defprop --gray-7)
(o/defprop --gray-8)
(o/defprop --gray-9)
(o/defprop --gray-10)
(o/defprop --gray-11)
(o/defprop --gray-12)

(o/defprop --accent-1)
(o/defprop --accent-2)
(o/defprop --accent-3)
(o/defprop --accent-4)
(o/defprop --accent-5)
(o/defprop --accent-6)
(o/defprop --accent-7)
(o/defprop --accent-8)
(o/defprop --accent-9)
(o/defprop --accent-10)
(o/defprop --accent-11)
(o/defprop --accent-12)

;; alpha variants, blend on top of backgrounds
(o/defprop --accent-a1)
(o/defprop --accent-a2)
(o/defprop --accent-a3)
(o/defprop --accent-a4)
(o/defprop --accent-a5)
(o/defprop --accent-a6)
(o/defprop --accent-a7)
(o/defprop --accent-a8)
(o/defprop --accent-a9)
(o/defprop --accent-a10)
(o/defprop --accent-a11)
(o/defprop --accent-a12)

(o/defprop --accent-surface)
(o/defprop --accent-indicator)
(o/defprop --accent-track)
(o/defprop --accent-contrast)

(o/defprop --gray-surface)
(o/defprop --gray-indicator)
(o/defprop --gray-track)
(o/defprop --gray-contrast)

(o/defprop --separator-size)

(o/defprop --space-1)
(o/defprop --space-2)
(o/defprop --space-3)
(o/defprop --space-4)
(o/defprop --space-5)
(o/defprop --space-6)
(o/defprop --space-7)
(o/defprop --space-8)
(o/defprop --space-9)

(o/defprop --line-height-1)
(o/defprop --line-height-2)
(o/defprop --line-height-3)
(o/defprop --line-height-4)
(o/defprop --line-height-5)
(o/defprop --line-height-6)
(o/defprop --line-height-7)
(o/defprop --line-height-8)
(o/defprop --line-height-9)

(o/defprop --font-size-1)
(o/defprop --font-size-2)
(o/defprop --font-size-3)
(o/defprop --font-size-4)
(o/defprop --font-size-5)
(o/defprop --font-size-6)
(o/defprop --font-size-7)
(o/defprop --font-size-8)
(o/defprop --font-size-9)

(o/defprop --table-row-background-color)

(def known-radix-interactive-classes
  "A set of all known radix interactive classes. This includes all elements which
   may be mouse interacted on the canvas html portals, and should not have mouse events
   pass through them."
  #{"rt-TextAreaRoot" "rt-TextFieldRoot"})

(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#theme"}
  Theme
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Theme)))

;; Layout
(def ^{:doc "https://www.radix-ui.com/themes/docs/components/box"}
  Box
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Box)))
(def ^{:doc "https://www.radix-ui.com/themes/docs/components/flex"}
  Flex
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Flex)))
(def ^{:doc "https://www.radix-ui.com/themes/docs/components/grid"}
  Grid
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Grid)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#container"}
  Container
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Container)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#section"}
  Section
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Section)))

;; Text
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#commontext"}
  Text
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Text)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#heading"}
  Heading
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Heading)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#blockquote"}
  Blockquote
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Blockquote)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#code"}
  Code
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Code)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#em"}
  Em
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Em)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#kbd"}
  Kbd
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Kbd)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#link"}
  Link
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Link)))

;; TODO can't call it `link` as it clashes with the hai.ui.components.link NS of which it's
;; components don't have the correct colour when used in web-app and I don't feel like sorting out
;; right now.
(defn link-button
  [props & children]
  #?(:cljs
     (into [Link (assoc props
                        :style {:cursor "pointer"}
                        :href "#"
                        :variant "ghost")]
           children)))

(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#quote"}
  Quote
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Quote)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#strong"}
  Strong
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Strong)))

;; Components
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#alertdialogalertdialogroot"}
  AlertDialogRoot
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/AlertDialog.Root)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#alertdialogalertdialogtrigger"}
  AlertDialogTrigger
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/AlertDialog.Trigger)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#alertdialogalertdialogcontent"}
  AlertDialogContent
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/AlertDialog.Content)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#alertdialogalertdialogtitle"}
  AlertDialogTitle
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/AlertDialog.Title)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#alertdialogalertdialogdescription"}
  AlertDialogDescription
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/AlertDialog.Description)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#alertdialogalertdialogaction"}
  AlertDialogAction
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/AlertDialog.Action)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#alertdialogalertdialogcancel"}
  AlertDialogCancel
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/AlertDialog.Cancel)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#aspectratio"}
  AspectRatio
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/AspectRatio)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#avataravatar"}
  Avatar
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Avatar)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#badge"}
  Badge
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Badge)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#button"}
  Button
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Button)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#calloutcalloutroot"}
  CalloutRoot
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Callout.Root)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#calloutcallouticon"}
  CalloutIcon
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Callout.Icon)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#calloutcallouttext"}
  CalloutText
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Callout.Text)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#card"}
  Card
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Card)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#checkbox"}
  Checkbox
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Checkbox)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#checkboxgroupcheckboxgrouproot"}
  CheckboxGroupRoot
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/CheckboxGroup.Root)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#checkboxgroupcheckboxgroupitem"}
  CheckboxGroupItem
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/CheckboxGroup.Item)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#checkboxcardscheckboxcardsroot"}
  CheckboxCardsRoot
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/CheckboxCards.Root)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#checkboxcardscheckboxcardsitem"}
  CheckboxCardsItem
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/CheckboxCards.Item)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#contextmenucontextmenuroot"}
  ContextMenuRoot
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/ContextMenu.Root)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#contextmenucontextmenutrigger"}
  ContextMenuTrigger
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/ContextMenu.Trigger)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#contextmenucontextmenucontent"}
  ContextMenuContent
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/ContextMenu.Content)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#contextmenucontextmenulabel"}
  ContextMenuLabel
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/ContextMenu.Label)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#contextmenucontextmenugroup"}
  ContextMenuGroup
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/ContextMenu.Group)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#contextmenucontextmenuradiogroup"}
  ContextMenuRadioGroup
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/ContextMenu.RadioGroup)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#contextmenucontextmenuradioitem"}
  ContextMenuRadioItem
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/ContextMenu.RadioItem)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#contextmenucontextmenuitem"}
  ContextMenuItem
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/ContextMenu.Item)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#contextmenucontextmenucheckboxitem"}
  ContextMenuCheckboxItem
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/ContextMenu.CheckboxItem)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#contextmenucontextmenusub"}
  ContextMenuSub
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/ContextMenu.Sub)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#contextmenucontextmenusubtrigger"}
  ContextMenuSubTrigger
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/ContextMenu.SubTrigger)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#contextmenucontextmenusubcontent"}
  ContextMenuSubContent
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/ContextMenu.SubContent)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#datalistdatalistroot"}
  DataListRoot
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/DataList.Root)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#datalistdatalistitem"}
  DataListItem
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/DataList.Item)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#datalistdatalistlabel"}
  DataListLabel
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/DataList.Label)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#datalistdatalistvalue"}
  DataListValue
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/DataList.Value)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#dialogdialogroot"}
  DialogRoot
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Dialog.Root)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#dialogdialogtrigger"}
  DialogTrigger
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Dialog.Trigger)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#dialogdialogcontent"}
  DialogContent
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Dialog.Content)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#dialogdialogtitle"}
  DialogTitle
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Dialog.Title)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#dialogdialogdescription"}
  DialogDescription
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Dialog.Description)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#dialogdialogclose"}
  DialogClose
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Dialog.Close)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#dropdownmenudropdownmenuseparator"}
  DropdownMenuSeparator
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/DropdownMenu.Separator)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#dropdownmenudropdownmenuroot"}
  DropdownMenuRoot
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/DropdownMenu.Root)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#dropdownmenudropdownmenutrigger"}
  DropdownMenuTrigger
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/DropdownMenu.Trigger)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#dropdownmenudropdownmenutriggericon"}
  DropdownMenuTriggerIcon
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/DropdownMenu.TriggerIcon)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#dropdownmenudropdownmenucontent"}
  DropdownMenuContent
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/DropdownMenu.Content)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#dropdownmenudropdownmenulabel"}
  DropdownMenuLabel
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/DropdownMenu.Label)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#dropdownmenudropdownmenuitem"}
  DropdownMenuItem
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/DropdownMenu.Item)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#dropdownmenudropdownmenugroup"}
  DropdownMenuGroup
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/DropdownMenu.Group)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#dropdownmenudropdownmenuradiogroup"}
  DropdownMenuRadioGroup
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/DropdownMenu.RadioGroup)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#dropdownmenudropdownmenuradioitem"}
  DropdownMenuRadioItem
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/DropdownMenu.RadioItem)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#dropdownmenudropdownmenucheckboxitem"}
  DropdownMenuCheckboxItem
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/DropdownMenu.CheckboxItem)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#dropdownmenudropdownmenusub"}
  DropdownMenuSub
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/DropdownMenu.Sub)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#dropdownmenudropdownmenusubtrigger"}
  DropdownMenuSubTrigger
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/DropdownMenu.SubTrigger)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#dropdownmenudropdownmenusubcontent"}
  DropdownMenuSubContent
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/DropdownMenu.SubContent)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#hovercardhovercard"}
  HoverCardRoot
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/HoverCard.Root)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#hovercardhovercardtrigger"}
  HoverCardTrigger
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/HoverCard.Trigger)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#hovercardhovercardcontent"}
  HoverCardContent
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/HoverCard.Content)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#iconbutton"}
  IconButton
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/IconButton)))
(defn dialog-close-x
  "Renders an ✕ icon button absolutely positioned in the top-right corner of a DialogContent."
  []
  #?(:cljs
     [DialogClose
      [IconButton
       {:size "1" :variant "ghost" :color "gray"
        :style {:position "absolute" :top "12px" :right "15px"}}
       "✕"]]))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#inset"}
  Inset
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Inset)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#popoverpopoverroot"}
  PopoverRoot
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Popover.Root)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#popoverpopovertrigger"}
  PopoverTrigger
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Popover.Trigger)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#popoverpopovercontent"}
  PopoverContent
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Popover.Content)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#popoverpopoverclose"}
  PopoverClose
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Popover.Close)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#progress"}
  Progress
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Progress)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#radio"}
  Radio
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Radio)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#radiogroupradiogrouproot"}
  RadioGroupRoot
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/RadioGroup.Root)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#radiogroupradiogroupitem"}
  RadioGroupItem
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/RadioGroup.Item)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#radiocardsradiocardsroot"}
  RadioCardsRoot
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/RadioCards.Root)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#radiocardsradiocardsitem"}
  RadioCardsItem
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/RadioCards.Item)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#scrollarea"}
  ScrollArea
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/ScrollArea)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#segmentedcontrolsegmentedcontrolroot"}
  SegmentedControlRoot
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/SegmentedControl.Root)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#segmentedcontrolsegmentedcontrolitem"}
  SegmentedControlItem
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/SegmentedControl.Item)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#selectselectroot"}
  SelectRoot
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Select.Root)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#selectselecttrigger"}
  SelectTrigger
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Select.Trigger)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#selectselectcontent"}
  SelectContent
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Select.Content)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#selectselectitem"}
  SelectItem
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Select.Item)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#selectselectgroup"}
  SelectGroup
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Select.Group)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#selectselectlabel"}
  SelectLabel
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Select.Label)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#selectselectseparator"}
  SelectSeparator
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Select.Separator)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#separator"}
  Separator
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Separator)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#skeleton"}
  Skeleton
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Skeleton)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#slider"}
  Slider
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Slider)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#spinner"}
  Spinner
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Spinner)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#switch"}
  Switch
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Switch)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#tabletableroot"}
  TableRoot
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Table.Root)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#tabletableheader"}
  TableHeader
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Table.Header)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#tabletablebody"}
  TableBody
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Table.Body)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#tabletablerow"}
  TableRow
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Table.Row)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#tabletablecell"}
  TableCell
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Table.Cell)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#tabletablecolumnheadercell"}
  TableColumnHeaderCell
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Table.ColumnHeaderCell)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#tabletablerowheadercell"}
  TableRowHeaderCell
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Table.RowHeaderCell)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#tabstabsroot"}
  TabsRoot
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Tabs.Root)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#tabstabslist"}
  TabsList
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Tabs.List)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#tabstabstrigger"}
  TabsTrigger
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Tabs.Trigger)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#tabstabscontent"}
  TabsContent
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Tabs.Content)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#tabnavtabnavroot"}
  TabNavRoot
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/TabNav.Root)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#tabnavtabnavlink"}
  TabNavLink
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/TabNav.Link)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#textarea"}
  TextArea
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/TextArea)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#textfieldtextfieldroot"}
  TextFieldRoot
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/TextField.Root)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#textfieldtextfieldslot"}
  TextFieldSlot
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/TextField.Slot)))
(def ^{:doc "https://github.com/humbleai/hai/blob/main/components/radix-themes-docs/radix-themes-props.md#tooltip"}
  Tooltip
  #?(:cljs (reagent/adapt-react-class radix-ui-themes/Tooltip)))
